import { TeamsUserCredential } from "@microsoft/teamsfx";
import config from "../config";

export const Auth = {
  getToken: async (scopes: string | string[], claims?: string) => {
    const credential = Auth.getCredential();
    return await credential.getToken(scopes, { claims });
  },
  getUserInfo: async () => {
    const credential = Auth.getCredential();
    return credential.getUserInfo();
  },
  getCredential: () => {
    return new TeamsUserCredential({
      initiateLoginEndpoint: config.initiateLoginEndpoint!,
      clientId: config.clientId!,
    });
  }
}